<template>
  <div
    class="c-outages-results"
    :class="{ 'c-outages-results--list-view': outagePageView === 'list' }"
  >
    <component
      v-for="outage in getAllFilteredOutages"
      :key="outage.type + outage.id"
      :outage="outage"
      :is="
        outage.type == 'planned'
          ? 'planned-outage-result'
          : 'unplanned-outage-result'
      "
    />
    <div
      v-if="getAllFilteredOutages.length === 0"
      class="c-outages-results__no-outages"
    >
      <div class="c-outages-results__no-outages-inner">
        <h3 class="c-outages-results__no-outages-title">
          {{ noOutagesText() }}
        </h3>
        <p class="c-outages-results__no-outages-text">Are you without power?</p>
        <a
          v-if="cmsContent.noOutagesFoundLink"
          :href="cmsContent.noOutagesFoundLink"
          class="c-outages-results__no-outages-button readmore readmore__linkBox readmore__linkBox--orange"
        >
          <p>{{ cmsContent.noOutagesFoundText }}</p>
          <span></span>
        </a>
      </div>
    </div>


    <component v-if="getAllFilteredOutages.length === 0 && cmsContent.noOutagesFeaturePanel" :is="cmsContent.noOutagesFeaturePanel.Link ? 'a':'span'" :href="cmsContent.noOutagesFeaturePanel.Link || ''">
      <img
        :src="cmsContent.noOutagesFeaturePanel.Image"
        class="c-outages-results__feature-panel-image"
      />
    </component>

  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapGetters } from "vuex";

import PlannedOutageResult from "./PlannedOutageResult.vue";
import UnplannedOutageResult from "./UnplannedOutageResult.vue";

export default {
  created() {},
  components: {
    PlannedOutageResult,
    UnplannedOutageResult,
  },
  mounted() {},
  computed: {
    ...mapFields([
      "outagePageView",
      "searchText",
      "filterMarkerSelectedLocation",
      "filterOption",
      "cmsContent",
    ]),
    ...mapGetters(["getAllFilteredOutages"]),
  },
  methods: {
    noOutagesText() {
      if (this.searchText != "" || this.filterMarkerSelectedLocation != null)
        return "No outages found for this search";
      if (this.filterOption === "current")
        return "There are currently no known outages";
      if (this.filterOption === "recent")
        return "There are currently no recent outages";
      if (this.filterOption === "scheduled")
        return "There are currently no scheduled outages";
      return "";
    },
  },
};
</script>

<style lang="scss"></style>
